import { Injectable } from "@angular/core";
import { CanActivate, CanLoad, GuardResult, MaybeAsync, Router, } from "@angular/router";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class AuthenticationByCredentialsGuard implements CanActivate, CanLoad {

  constructor(private router: Router) {
  }

  canActivate(): MaybeAsync<GuardResult> {
    if (environment['forcedCompanyName']) {
      this.router.navigate(['/sso/login']);
      return false;
    }
    return true;
  }

  canLoad(): MaybeAsync<GuardResult> {
    return !environment['forcedCompanyName'];
  }

}
